import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import stringsEn from '../assets/locales/strings.en.json';
import stringsFr from '../assets/locales/strings.fr.json';

export type SupportedLanguage = 'en' | 'fr' | 'ar' | 'de' | 'it' | 'pt' | 'ru' | 'tr' | 'zh';

export interface LanguageInfo {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
}

export const SUPPORTED_LANGUAGES: LanguageInfo[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
];

const resources = {
  en: { translation: stringsEn },
  fr: { translation: stringsFr },
  ar: { translation: stringsFr },
} as const;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    compatibilityJSON: 'v4',
    debug: import.meta.env.DEV,
  });

export default i18n;

export const changeLanguage = (language: SupportedLanguage): void => {
  i18n.changeLanguage(language);
};

export const getCurrentLanguage = (): SupportedLanguage => {
  return i18n.language as SupportedLanguage;
};

export const isLanguageSupported = (language: string): language is SupportedLanguage => {
  return SUPPORTED_LANGUAGES.map((lang) => lang.code).includes(language as SupportedLanguage);
};
